import { createTokenManager } from '@gastrosoft/shared/auth';

const AUTH_ENDPOINT = import.meta.env.VITE_AUTH_ENDPOINT;

export const tokenManager = createTokenManager({ authEndpoint: AUTH_ENDPOINT });
export default tokenManager;
